import * as React from "react";
import { Selectors, Actions, State } from "@grandvisionhq/auth";
import { LoaderScreen } from "@grandvisionhq/common";
import { connect } from "@grandvisionhq/state";
class Protected extends React.Component {
  constructor() {
    super(...arguments);
    this.redirectOut = () => {
      const query = this.returnPath ? `returnPath=${encodeURIComponent(`/${this.returnPath}`)}` : void 0;
      this.props.goto({ route: "auth.login", query, fullPageRefresh: true });
    };
  }
  componentDidMount() {
    this.returnPath = window.location.pathname.replace("//", "/").replace(/^\//, "");
    if (State.isInitialized(this.props.auth)) {
      this.props.recoverSession();
    } else if (State.isLoggedOut(this.props.auth)) {
      this.redirectOut();
    } else {
      this.props.assertSession();
    }
  }
  render() {
    const { auth } = this.props;
    if (State.isLoggedIn(auth)) {
      return this.props.children;
    }
    return /* @__PURE__ */ React.createElement(LoaderScreen, { height: 50 });
  }
  componentDidUpdate() {
    if (State.isLoggedOut(this.props.auth)) {
      this.redirectOut();
    }
  }
}
const mapStateToProps = (state) => ({
  auth: Selectors.getAuth(state)
});
const mapDispatchToProps = {
  goto: Actions.goto,
  recoverSession: Actions.LoginActions.recoverSession,
  assertSession: Actions.LoginActions.assertSession
};
const Protected$1 = connect(mapStateToProps, mapDispatchToProps)(Protected);
export {
  Protected,
  Protected$1 as default,
  mapDispatchToProps,
  mapStateToProps
};
//# sourceMappingURL=Protected.js.map
